import { useEffect, useState } from "react";
import { Play, RotateCcw } from "lucide-react";

export const NextEpisodeOverlay = ({ next, onPlay, onCancel, seconds = 8 }) => {
  const [left, setLeft] = useState(seconds);
  useEffect(() => {
    if (left <= 0) return onPlay();
    const t = setTimeout(() => setLeft((l) => l - 1), 1000);
    return () => clearTimeout(t);
  }, [left, onPlay]);
  return (
    <div data-testid="next-episode-overlay" className="absolute bottom-28 right-4 sm:right-10 z-30 w-[300px] sm:w-[360px] overflow-hidden rounded-2xl glass bg-black/85 fade-up">
      <img src={next.thumbnail_url} alt="" className="h-36 w-full object-cover" />
      <div className="p-4">
        <p className="eyebrow !text-[0.65rem]">Next episode in <span data-testid="next-episode-countdown" className="text-white">{left}s</span></p>
        <p className="mt-1 font-display text-base text-white">S{next.season}:E{next.number} · {next.title}</p>
        <div className="mt-4 flex gap-2">
          <button data-testid="next-episode-play-now-btn" onClick={onPlay} className="btn-gold flex-1 py-2 text-sm"><Play className="h-4 w-4 fill-current" /> Play now</button>
          <button data-testid="next-episode-cancel-btn" onClick={onCancel} className="btn-ghost-gold px-4 py-2 text-sm">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export const EndedOverlay = ({ onReplay, onBack }) => (
  <div data-testid="player-ended-overlay" className="absolute inset-0 z-30 grid place-items-center bg-black/70">
    <div className="text-center space-y-5">
      <p className="eyebrow">Thanks for watching</p>
      <div className="flex gap-3 justify-center">
        <button data-testid="player-replay-btn" onClick={onReplay} className="btn-gold px-6 py-3"><RotateCcw className="h-4 w-4" /> Replay</button>
        <button data-testid="player-ended-back-btn" onClick={onBack} className="btn-ghost-gold px-6 py-3">Back to details</button>
      </div>
    </div>
  </div>
);
